import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

const _c0 = ["*"];
class XpoResponsiveLoadingSpinner {
    constructor() {
        // default spinner diameter from angular material.
        this.diameter = 100;
    }
}
XpoResponsiveLoadingSpinner.ɵfac = function XpoResponsiveLoadingSpinner_Factory(t) { return new (t || XpoResponsiveLoadingSpinner)(); };
XpoResponsiveLoadingSpinner.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoResponsiveLoadingSpinner, selectors: [["xpo-responsive-loading-spinner"]], hostAttrs: [1, "xpo-ResponsiveLoadingSpinner"], inputs: { diameter: "diameter" }, ngContentSelectors: _c0, decls: 3, vars: 1, consts: [[3, "diameter"], [1, "xpo-ResponsiveLoadingSpinner-text"]], template: function XpoResponsiveLoadingSpinner_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelement(0, "mat-spinner", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("diameter", ctx.diameter);
    } }, directives: [i1.MatSpinner], styles: [".flex--stretch{flex:1}.xpo-ResponsiveLoadingSpinner{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;min-height:100px;min-width:100px;width:100%}.xpo-ResponsiveLoadingSpinner-text{color:#0868ac;margin-top:24px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoResponsiveLoadingSpinner, [{
        type: Component,
        args: [{
                selector: 'xpo-responsive-loading-spinner',
                templateUrl: './responsive-loading-spinner.component.html',
                styleUrls: ['./responsive-loading-spinner.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-ResponsiveLoadingSpinner' },
            }]
    }], null, { diameter: [{
            type: Input
        }] }); })();

class XpoResponsiveLoadingSpinnerModule {
}
XpoResponsiveLoadingSpinnerModule.ɵfac = function XpoResponsiveLoadingSpinnerModule_Factory(t) { return new (t || XpoResponsiveLoadingSpinnerModule)(); };
XpoResponsiveLoadingSpinnerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoResponsiveLoadingSpinnerModule });
XpoResponsiveLoadingSpinnerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatProgressSpinnerModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoResponsiveLoadingSpinnerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatProgressSpinnerModule],
                declarations: [XpoResponsiveLoadingSpinner],
                exports: [XpoResponsiveLoadingSpinner],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoResponsiveLoadingSpinnerModule, { declarations: [XpoResponsiveLoadingSpinner], imports: [CommonModule, MatProgressSpinnerModule], exports: [XpoResponsiveLoadingSpinner] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoResponsiveLoadingSpinner, XpoResponsiveLoadingSpinnerModule };
